import { render, staticRenderFns } from "./hazopScenario.vue?vue&type=template&id=51ea60a0"
import script from "./hazopScenario.vue?vue&type=script&lang=js"
export * from "./hazopScenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ea60a0')) {
      api.createRecord('51ea60a0', component.options)
    } else {
      api.reload('51ea60a0', component.options)
    }
    module.hot.accept("./hazopScenario.vue?vue&type=template&id=51ea60a0", function () {
      api.rerender('51ea60a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/hazop/hazopScenario.vue"
export default component.exports